var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconShuffle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 21,
    viewBox: "0 0 25 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.75 2V4.125H15.6875C14.9438 4.125 14.4975 4.3375 14.03 4.9325L11.0338 8.715L7.7825 4.9325C7.315 4.38 6.8475 4.125 6.125 4.125H4V6.25H6.125C6.01875 6.25 6.14625 6.335 6.18875 6.31375L9.6525 10.3725L6.125 14.75H4V16.875H6.125C6.86875 16.875 7.315 16.6625 7.7825 16.0675L11.0338 12.0087L14.5612 16.0675C15.0287 16.62 15.4963 16.875 16.2188 16.875H16.75V19L21 15.8125L16.75 12.625V14.75H16.2825C16.2613 14.7288 16.1762 14.665 16.155 14.6862L12.4362 10.3088L15.6875 6.25H16.75V8.375L21 5.1875L16.75 2Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShuffle);
export default __webpack_public_path__ + "static/media/icon-shuffle.7ea97e13bca55121e3e8d2189a11597a.svg";
export { ForwardRef as ReactComponent };